//
//
//
//
//
//
//

	import $ from 'jquery'
	export default {
		props: {
			id: {
				type: String,
				default: "piechart"
			},
			width: {
				type: String,
				default: "100%"
			},
			height: {
				type: String,
				default: "100%"
			},
			name: {
				type: String,
				default: ''
			},
			datas: {
				type: Array,
				default: []
				// default: (()=>{
				//   return [
				//     {name:'测试1',value:100},
				//     {name:'测试2',value:200},
				//     {name:'测试3',value:300},
				//   ]
				// })
			},
			title: {
				type: String,
				default: ""
			}
		},
		data() {
			return {
				chart: null
			};
		},
		watch: {
			datas() {
				if (this.chart) {
					this.chart.dispose();
					this.chart = null;
				}
				this.initChart();
			},
		},
		mounted() {
			setTimeout(() => {
				this.initChart();
			}, 500);
			$(window).resize(() => {
				if (this.chart) {
					this.chart.dispose();
					this.chart = null;
				}
				this.initChart();
			});
		},
		beforeDestroy() {
			if (!this.chart) {
				return;
			}
			this.chart.dispose();
			this.chart = null;
		},
		methods: {
			fontSize(res) {
				let docEl = document.documentElement,
					clientWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
				if (!clientWidth) return;
				let fontSize = 100 * (clientWidth / 1920);
				return res * fontSize;
			},
			initChart() {
				let nameData = [],
					dataList = [],
					fontSize;
				fontSize = this.fontSize(0.14)
				let nameWidth = fontSize * 12;
				let percentWidth = fontSize * 4.8;
				dataList = this.datas
				if (this.datas.length) {
					this.datas.forEach(item => {
						nameData.push({
							name: item.name,
							value:item.value
							// textStyle: {
							//  color: 'red'
							// }
						})
					})
				}
				this.chart = this.$echarts.init(document.getElementById(this.id));
				this.chart.setOption({
					// tooltip: {
					//   position: ['20%', '60%'],
					//   trigger: "item",
					//   formatter: "{a} <br/>{b}: {c} ({d}%)"
					// },
					legend: {
						icon: "circle",
						itemWidth: fontSize,
						itemHeight: fontSize,
						orient: "vertical",
						right: "4%",
						top: "center",
						// itemGap: fontSize,
						textStyle: {
							fontSize: fontSize,
							color: '#FFFFFF',
							rich: {
								a: {
									color: '#FFFFFF',
									width: nameWidth,
									fontSize: fontSize,
								},
								b0: {
									color: '#12D175',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize
								},
								b1: {
									color: '#B3EE14',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize,
								},
								b2: {
									color: '#F6CF19',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize,
								},
								b3: {
									color: '#FF670B',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize,
								},
								b4: {
									color: '#E335FF',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize,
								},
								b5: {
									color: '#2485FF',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize,
								},
								b6: {
									color: '#FF3C2D',
									width: percentWidth,
									align: 'right',
									fontSize: fontSize,
								}

							}
						},
						data: nameData,
						formatter: function(name) {
							// 获取legend显示内容
							let data = dataList;
							let total = 0;
							let tarValue = 0;
							let index;
							for (let i = 0, l = data.length; i < l; i++) {
								total += data[i].value;
								if (data[i].name == name) {
									tarValue = data[i].value;
									index = i
								}
							}
              var p = '0%'
              if (tarValue && total) {
                p = (tarValue / total * 100).toFixed(2) + '%';
              }
							return `{a| ${name}}` + '' +`{b${index}| ${p}}`
							// return `{a| ${name}}` + '     ' +`{b${index}| ${tarValue}`+'件'+'  '+ `(${p})}`
							// return `{a| ${name}}` + '       ' + `{b${index}| ${p}}`
							// let arr = [
							//   "{a|" + name + "}",
							//   "{b|" + p + "%}"
							// ];
							// return arr.join(' ');
							// return name + ' ' + ' ' + p + '%';
						},
					},
					series: [
            {
						name: this.name,
						type: "pie",
						radius: ["15%", "63%"],
						// center:["30%","50%"],
						center: ["25.6%", "52%"],
						avoidLabelOverlap: false,
						label: {
							normal: {
								show: false,
								position: "center"
							},
							// emphasis: {
							//   show: true,
							//   textStyle: {
							//     fontSize: "0.3rem",
							//     fontWeight: "bold"
							//   }
							// }
						},
						labelLine: {
							normal: {
								show: false
							}
						},
						itemStyle: {
							color: function(params) {
								//自定义颜色
								var colorList = [
									"#12D175",
									"#B3EE14",
									"#F6CF19",
									"#FF670B",
									"#E335FF",
									"#2485FF",
									"#FF3C2D"

								];
								return colorList[params.dataIndex];
							}
						},
						data: this.datas
					}]
				});
			}
		}
	};



// WEBPACK FOOTER //
// ./src/components/pieChart.vue